import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import useFetch from '../../../../../hooks/useAxios';
import Button from '../../../../shared/Button';
import Input from '../../../../shared/Input'
import close from "../../../../../assets/img/icons/close.svg"
const WageForCodeRes = ({closeModal,apiWageList,edit,info}) => {
    const [WagePerc, setWagePerc] = useState()
    console.log("info",info);

    const {
        handleSubmit,
        formState: { errors, isValid },
        control,
        reset
      } = useForm({
       defaultValues:{
        residence_code:edit?info.residence_code :"",
        wage_percentage:edit?info.wage_percentage :"",
       }
      });
      const postWageForAll = useFetch({
        method: "post",
        url: "api/admin/wages/store/by-code",
        noHeader: false,
        trigger: false,
        data:WagePerc,
        caller:apiWageList,
        argFunc:res=>{
            toast.success("کارمزد ایجاد شد.")
            closeModal()
        },
        errMessage:err=>{
            toast.error(err.message)
        }
      });
      const putWageForAll = useFetch({
        method: "post",
        url: `api/admin/wages/update/${info?.id}`,
        noHeader: false,
        trigger: false,
        data:WagePerc,
        caller:apiWageList,
        argFunc:res=>{
            toast.success("کارمزد به روزرسانی شد.")
            closeModal()
        },
        errMessage:err=>{
            toast.error(err.message)
        }
      });
    const onSubmit = (data)=>{
        setWagePerc({...data})
    }
    useEffect(() => {
      
        if(WagePerc){
            postWageForAll.reFetch() 
            if( edit){
              putWageForAll.reFetch()
            }
        }

        
    }, [WagePerc])
    
  return (
    <div className='ModalBackground WageForAllRes'>

        <div className='ModalBackground--container p-[32px] relative'>
            <button onClick={closeModal} className=' absolute left-[24px] top-[24px]'>
                <img src={close}/>
            </button>

            <h3 className='text-[#00A6A6] text-[24px] font-[700]'>کارمرزد اختصاصی</h3>
            <p className='text-[#5B5F64] text-[16px] font-[400] mt-[12px] mb-[64px]'>
            برای هر اقامتگاه مد نظر خود می توانید کارمزد اختصاصی اعمال کنید .
            </p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='text-[#292D32] text-[20px] font-[700]'>
                میزان کارمزد
                </div>
          
            <Input
            name="residence_code"
            control={control}
            errors={errors}
            placeholder="کد اقامتگاه"
            
            className="admin-input my-[20px]"
            register={{
              required: "  کارمزد عمومی اجباری است"
            }}
          />
            <Input
            name="wage_percentage"
            control={control}
            errors={errors}
            placeholder="میزان کارمزد"
            
            className="wage-input my-[20px]"
            register={{
              required: "  کارمزد عمومی اجباری است"
            }}
          />
          <Button fullwidth varient="primary">تایید و اعمال</Button>
          
            </form>
        </div>
    </div>
  )
}


export default WageForCodeRes